import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-clinic-telediagnosis',
  imports: [RouterModule],
  templateUrl: './telediagnosis.component.html',
  styleUrl: './telediagnosis.component.scss',
})
export class ClinicTelediagnosisComponent {}
